declare global{
    interface Number {
      /**
       * Round the number to specified places of decimal
       * @parameter decimalPlaces: number of places of decimal to round
       */
      roundTo: (decimalPlaces) => number;
    }
}

Number.prototype.roundTo = function(decimalPlaces) {
  return parseFloat(this.toFixed(decimalPlaces));
}
export {};